module.exports = __webpack_public_path__ + "img/not_mobile_press@2x.c0d6946.webp";